/**
 * SSOT — תפוסת חדרים לטופס נוסעים / snapshot / booking (מלונות בלבד).
 * מאחד adults/AdultsCount, kids/KidsAges, infants — כמו בחיפוש ובפרופיל מלון.
 */

import { normalizePassengerRoomArrays } from "./buildPassengersForGemonixBooking";
import { normalizeSearchPhraseRoomForWizard } from "./multiRoomProfileSelectionModel";

/**
 * @param {unknown} rawRooms
 * @returns {{ AdultsCount: number, KidsAges: number[], InfantsCount: number, room_index: number }[]}
 */
export function resolveHotelPassengerFormRooms(rawRooms) {
  if (!Array.isArray(rawRooms) || rawRooms.length === 0) return [];
  return rawRooms.map((room, index) =>
    normalizeSearchPhraseRoomForWizard(room, index)
  );
}

/** @param {unknown} rawRooms */
export function hotelPassengerLayoutSignature(rawRooms) {
  return resolveHotelPassengerFormRooms(rawRooms)
    .map(
      (r) =>
        `${r.AdultsCount}-${(r.KidsAges || []).length}-${r.InfantsCount ?? 0}`
    )
    .join("|");
}

/** @param {unknown} passengerRooms */
export function passengerInfoSlotCountSignature(passengerRooms) {
  const norm = normalizePassengerRoomArrays(passengerRooms);
  return norm
    .map((room) => (Array.isArray(room) ? room.length : room ? 1 : 0))
    .join("|");
}

/** @param {unknown} rawRooms */
export function summarizeHotelPassengerOccupancy(rawRooms) {
  const rooms = resolveHotelPassengerFormRooms(rawRooms);
  let adults = 0;
  let children = 0;
  let infants = 0;
  for (const r of rooms) {
    adults += Number(r.AdultsCount) || 0;
    children += Array.isArray(r.KidsAges) ? r.KidsAges.length : 0;
    infants += Number(r.InfantsCount) || 0;
  }
  return {
    roomCount: rooms.length,
    adults,
    children,
    infants,
    totalGuestsResolved: adults + children + infants,
  };
}

/** @param {Record<string, unknown>} payload */
export function logHotelPassengersFormCountTrace(payload) {
  if (typeof import.meta !== "undefined" && !import.meta.env?.DEV) return;
  // eslint-disable-next-line no-console
  console.info("[HOTEL_PASSENGERS_FORM_COUNT_TRACE]", payload);
}
